import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../services/api';
import { runningPath } from '../utils/paths';
import PhotoGallery from './PhotoGallery';
import './PublicRunningPractice.css';

const formatDate = (dateStr) => {
  if (!dateStr) return 'TBA';
  return new Date(dateStr).toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const PublicRunningPractice = () => {
  const { shareToken } = useParams();
  const [practice, setPractice] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await api.getPublicRunningPractice(shareToken);
        setPractice(data);
      } catch (err) {
        setError(err.message || 'Shared practice not found');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [shareToken]);

  if (loading) return <div className="loading">Loading shared practice...</div>;
  if (error || !practice) return <div className="error-message">{error || 'Not found'}</div>;

  return (
    <div className="public-running-practice">
      <p className="public-running-practice__eyebrow">{practice.clubName || 'Running club'}</p>
      <h1>{practice.title}</h1>
      <p className="public-running-practice__when">{formatDate(practice.practiceDate)}</p>
      <p className="public-running-practice__meet">
        Gathering location: <strong>{practice.gatheringLocation}</strong>
      </p>
      {practice.gatheringNotes && <p>{practice.gatheringNotes}</p>}
      {practice.description && <p>{practice.description}</p>}

      {practice.route && (
        <section className="public-running-practice__section">
          <h2>Route</h2>
          <h3>{practice.route.title}</h3>
          {practice.route.distanceKm != null && <p>{practice.route.distanceKm} km</p>}
          <p>{[practice.route.surface, practice.route.difficulty].filter(Boolean).join(' · ')}</p>
          {practice.route.mapUrl && (
            <a href={practice.route.mapUrl} target="_blank" rel="noreferrer">
              Open map
            </a>
          )}
          <PhotoGallery photos={practice.route.photoUrls || []} />
        </section>
      )}

      <section className="public-running-practice__section">
        <h2>Team availability</h2>
        <div className="public-running-practice__counts">
          <span>Available {practice.availableCount}</span>
          <span>Maybe {practice.maybeCount}</span>
          <span>Reserve {practice.reserveCount}</span>
          <span>Unavailable {practice.unavailableCount}</span>
        </div>
        {practice.clubId && (
          <p>
            <Link to={runningPath(`/practices/${practice.id}`)}>Open practice to vote</Link>
          </p>
        )}
      </section>

      {(practice.photoUrls || []).length > 0 && (
        <section className="public-running-practice__section">
          <h2>Photos</h2>
          <PhotoGallery photos={practice.photoUrls} />
        </section>
      )}
    </div>
  );
};

export default PublicRunningPractice;
